import type { SeguidoItem } from '../services/seguidorService';

// PRPs/prds/correcoes-reuniao-05082026.prd.md AC-10 (plano AC-A1, AC-A3)
//
// Fonte única de exibição para um `SeguidoItem` (atleta, torneio ou liga seguidos).
// Extraída dos ramos antes duplicados em AtletaSeguindoTab.tsx e
// UserPrincipalSidebar.tsx — o ramo liga aqui é CORRIGIDO: antes produzia sempre
// `{ nome: 'Liga', username: '' }` (rótulo literal), agora resolve o nome/username/
// imagem reais da liga seguida. Função pura: sem fetch, sem import de React.
export interface ExibicaoSeguido {
  nome: string;
  username: string;
  imageUrl: string | null;
  path: string;
}

export function resolverExibicaoSeguido(seguido: SeguidoItem): ExibicaoSeguido {
  if (seguido.seguidoAtleta) {
    const usuario = seguido.seguidoAtleta.usuario;
    return {
      nome: usuario.nome,
      username: usuario.username,
      imageUrl: usuario.imagemUrl || null,
      path: `/userpage/${seguido.seguidoAtleta.id}`,
    };
  }

  if (seguido.seguidoTorneio) {
    return {
      nome: seguido.seguidoTorneio.nome,
      username: seguido.seguidoTorneio.username || '',
      imageUrl: seguido.seguidoTorneio.avatarUrl || null,
      path: `/tournamentsingle/${seguido.seguidoTorneio.id}`,
    };
  }

  if (seguido.seguidoLiga) {
    return {
      nome: seguido.seguidoLiga.nome,
      username: seguido.seguidoLiga.username,
      imageUrl: seguido.seguidoLiga.imagemUrl || null,
      path: `/league/${seguido.seguidoLiga?.id ?? seguido.seguidoLigaId}`,
    };
  }

  return {
    nome: '—',
    username: '',
    imageUrl: null,
    path: '',
  };
}
